import classNames from 'classnames';
import BasicSearchablePicker from 'components/foundation/pickers/basic-picker/BasicSearchablePicker/BasicSearchablePicker';
import useEquipmentDevices from 'hooks/models/equipment/useEquipmentDevices';
import { useEffect, useState } from 'react';
import { ClassName } from 'types/ClassName';

export interface IEquipmentGpsTrackerPickerProps {
  className?: ClassName;
  value: string | null;
  onSelect: (trackerId: string | null) => void;
}

const EquipmentGpsTrackerPicker = (props: IEquipmentGpsTrackerPickerProps) => {
  const { className, value, onSelect } = props;

  const getDevices = useEquipmentDevices();
  const [pickerData, setPickerData] = useState<{ id: string; name: string }[]>([]);

  useEffect(() => {
    getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getData = async () => {
    const allDevices = await getDevices(true);
    const trackers = allDevices.map((tracker) => ({
      id: `${tracker.id}`,
      name: tracker.esn,
    }));
    setPickerData(trackers);
  };
  const classes = classNames('equipment-gps-tracker-picker', className);

  return <BasicSearchablePicker className={classes} onSelect={onSelect} value={value} data={pickerData} />;
};

export default EquipmentGpsTrackerPicker;
